import { Component, forwardRef, Input } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";

import { FieldCoreComponent } from "../FieldCoreComponent";

export type MedSwitchPositions = "left" | "right";

@Component({
  selector: "med-switch",
  templateUrl: "./med-switch.component.html",
  styleUrls: ["./med-switch.component.scss"],
  providers: [{
    multi: true,
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MedSwitchComponent),
  }],
})
export class MedSwitchComponent extends FieldCoreComponent<boolean> {
  @Input() position: MedSwitchPositions = "left";

  get backwards(): boolean {
    return this.position === "right";
  }
}
